export interface ICarrierBranch {
  id: number;
  carrierRootId: number;
  documentNumber: string;
  corporateName?: string;
  email?: string;
  tradeName?: string;
  rootTradeName?: string;
  rootCompanyName?: string;
}

export enum EFeatureAvailability {
  ENABLED = 'ENABLED',
  DISABLED = 'DISABLED',
  HIDDEN = 'HIDDEN',
}

export enum CarrierRootRegisterStatusTypes {
  PENDING = 'PENDING',
  ACTIVE = 'ACTIVE',
  REJECTED = 'REJECTED',
}

export interface ICarrierRoot {
  id: number;
  documentRootNumber: number;
  companyName: string;
  tradeName: string;
  email: string;
  punitiveFee: number;
  creditLimit: number;
  baseInterest: number;
  dailyCreditLimit: number;
  totalCreditLimit: number;
  maxDueDays: number;
  registerStatusType: CarrierRootRegisterStatusTypes;
  bankName?: string;
  bankAccount?: string;
  bankBranch?: string;
  bankPix?: string;
  originChannel: string;
  tmsSystem: string;
  billingStatement: string;
  socialContract: string;
  optIn: boolean;
  contractEnabled: boolean;
  carrierBranches?: ICarrierBranch[];
  takerNtfctnBankName?: string;
  takerNtfctnBankAccount?: string;
  takerNtfctnBankBranch?: string;
  takerNtfctnOwnerName?: string;
  takerNtfctnOwnerDocumentNumber?: string;
  bankingMenuState: EFeatureAvailability;
  fileMenuState: EFeatureAvailability;
  pamcardMenuState: EFeatureAvailability;
  anticipationMenuState: EFeatureAvailability;
  guaranteeMenuState: EFeatureAvailability;
  reportsMenuState: EFeatureAvailability;
}

export interface ICarrierPartner {
  documentNumber: string;
  name: string;
  email: string;
  driverLicenseNumber: string;
  isSigner: boolean;
  carrierRootId: number;
}

export interface ICreditLimit {
  carrierRootId: number;
  dailyAvailable: number;
  dailyCreditLimit: number;
  totalAvailable: number;
  totalCreditLimit: number;
  totalVolume: number;
}

export interface ICarrierBaseInterest {
  value: number;
}

export interface ICarrierSecondaryOperation {
  id: number;
  tradeName: string;
}

export interface ICarriersRootFilters {
  documentRootNumber: string;
  documentNumber: string;
  tradeName: string;
  joinBranches: boolean;
}
